import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';
import { Simge } from '../bilesenler/Simge.js';

type Tur = 'olumlu' | 'hata';
interface Bildirim { id: number; tur: Tur; metin: string }

const Baglam = createContext<{ goster: (metin: string, tur?: Tur) => void } | null>(null);

export function BildirimSaglayici({ children }: { children: ReactNode }) {
  const [liste, setListe] = useState<Bildirim[]>([]);

  const kaldir = useCallback((id: number) => {
    setListe((l) => l.filter((b) => b.id !== id));
  }, []);

  const goster = useCallback((metin: string, tur: Tur = 'olumlu') => {
    const id = Date.now() + Math.random();
    setListe((l) => [...l, { id, tur, metin }]);
    window.setTimeout(() => kaldir(id), tur === 'hata' ? 7000 : 3500);
  }, [kaldir]);

  const deger = useMemo(() => ({ goster }), [goster]);

  return (
    <Baglam.Provider value={deger}>
      {children}
      {liste.length > 0 && (
        <div className="bildirim-alani" role="status" aria-live="polite">
          {liste.map((b) => (
            <div key={b.id} className={`bildirim ${b.tur}`}>
              <Simge ad={b.tur === 'olumlu' ? 'onay' : 'uyari'} className="simge" />
              <span>{b.metin}</span>
              <button className="kapat" onClick={() => kaldir(b.id)} aria-label="Kapat">
                <Simge ad="carpi" />
              </button>
            </div>
          ))}
        </div>
      )}
    </Baglam.Provider>
  );
}

export function useBildirim() {
  const b = useContext(Baglam);
  if (!b) throw new Error('useBildirim yalnızca BildirimSaglayici içinde kullanılabilir');
  return b.goster;
}
